import { Component, Inject } from '@angular/core';
import { MAT_LEGACY_SNACK_BAR_DATA as MAT_SNACK_BAR_DATA, MatLegacySnackBarRef as MatSnackBarRef } from '@angular/material/legacy-snack-bar';

@Component({
  selector: 'app-snack',
  templateUrl: './app-snack.component.html',
  styleUrls: ['./app-snack.component.scss']
})
export class AppSnackComponent {
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any, public snackBarRef: MatSnackBarRef<AppSnackComponent>) {}

  public actionDismissThis() {
    this.snackBarRef.closeWithAction();
  }
}
